import * as Notifications from 'expo-notifications';

import { fromPromise } from 'xstate';

import type { RequestPushNotificationPermissionOutput } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const requestPushNotificationPermissionActor =
  fromPromise<RequestPushNotificationPermissionOutput>(async () =>
    Notifications.requestPermissionsAsync({
      ios: {
        allowAlert: true,
        allowBadge: true,
        allowSound: true,
      },
      android: {
        // On Android, all available permissions are granted by default.
      },
    }),
  );
